/** @jsx jsx **/
import { jsx } from "@emotion/react";
import { useSetRecoilState } from "recoil";
import { navigate } from "gatsby";

import { modalToggleTermsOfServiceState } from "@recoil";
import { policyList } from "@constants";
import { checkWebView, getPathWithToken } from "@func";

import * as styles from "./policies.style";

export default function Policies() {
  const isWebView = checkWebView();

  const setTermsOfServiceToggle = useSetRecoilState(
    modalToggleTermsOfServiceState
  );

  const handleClick = () => {
    navigate(getPathWithToken("?termsofservice=true"));
    setTermsOfServiceToggle(true);
  };

  return (
    <div css={styles.rowPolicies}>
      <p css={styles.links} onClick={handleClick}>
        이용 약관 및 면책 조항
      </p>
      {!isWebView &&
        policyList.map((item, index) => (
          <a css={styles.links} key={item.itemName + index} href={item.link}>
            {item.itemName}
          </a>
        ))}
    </div>
  );
}
